import { Molecule, wrap } from 'AppReact';
import styled, { css } from 'styled-components';
import { PropertyIcon, PropertyName, UnitName } from './atoms';
import { SecondaryTextSm300, Initials, Icon } from 'atoms';
import { GenericWrapper, Mr3 } from 'wrappers';
import { getInitials } from 'utils/getInitials';
import { HomeSvg } from 'components/icons';

const template = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;

    height: 51px;
    padding-left: 27px;
    cursor: pointer;

    &:hover {
      background-color: ${`${theme?.colour?.primary}0D`} ;
    }
  `}
`;

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      component: PropertyIcon,
      name: 'PropertyIcon',
      renderIf: ({ property, showResident }) => property?.icon && !showResident,
      displayValue: ({ property }) => property.icon
    },
    {
      component: wrap(Initials, Mr3),
      name: 'ResidentIcon',
      renderIf: ({ unit, showResident}) => unit.tenant_name && unit.id && showResident,
      displayValue: ({ unit }) => getInitials(unit.tenant_name),
    },
    {
      component: wrap(Icon, Mr3),
      name: 'HomeIcon',
      renderIf: ({ unit, showResident }) => !unit.tenant_name && unit.id && showResident,
      displayValue: ({ }) => HomeSvg({ width: 30, height: 25 }),
    },
    {
      wrapper: GenericWrapper,
      name: 'PropertyName',
      atoms: [
        {
          component: UnitName,
          name: 'UnitName',
          displayValue: ({ unit }) => `Unit ${unit.number}`
        },
        {
          component: PropertyName,
          name: 'PropertyName',
          renderIf: ({showResident}) => !showResident,
          displayValue: ({ property }) => property.name
        },
        {
          component: SecondaryTextSm300,
          name: 'TenantName',
          rederIf: ({showResident}) => showResident,
          displayValue: ({ unit }) => unit.tenant_name ?? ''
        }
      ]
    }
  ]
})
